import { useState } from "react";
import type { TripWorkspace } from "@japangolmok/core";
export function SummaryCard({ trip }: { trip: TripWorkspace }) {
	const [url, setUrl] = useState(""),
		[error, setError] = useState("");
	async function create() {
		try {
			const canvas = document.createElement("canvas");
			canvas.width = 1080;
			canvas.height = 1350;
			const ctx = canvas.getContext("2d");
			if (!ctx) throw new Error("NO_CANVAS");
			ctx.fillStyle = "#fff";
			ctx.fillRect(0, 0, 1080, 1350);
			ctx.fillStyle = "#263d63";
			ctx.fillRect(0, 0, 1080, 260);
			ctx.fillStyle = "#fff";
			ctx.font = "bold 58px system-ui";
			ctx.fillText(`${trip.destinationCity}의 여행`, 64, 115);
			ctx.font = "30px system-ui";
			ctx.fillText(`${trip.startDate}–${trip.endDate}`, 64, 185);
			const completed = trip.days
				.flatMap((d) => d.items)
				.filter((i) => i.completed);
			ctx.fillStyle = "#263d63";
			ctx.font = "bold 40px system-ui";
			ctx.fillText(
				`다녀온 곳 ${completed.length}곳 · ${trip.days.length}일`,
				64,
				340,
			);
			let y = 430;
			for (const [index, day] of trip.days.slice(0, 7).entries()) {
				ctx.strokeStyle = ["#263d63", "#c94b32", "#4e6651"][index % 3]!;
				ctx.lineWidth = 8;
				ctx.beginPath();
				ctx.moveTo(85, y);
				ctx.lineTo(85, y + 75);
				ctx.stroke();
				ctx.fillStyle = ctx.strokeStyle;
				ctx.beginPath();
				ctx.arc(85, y + 25, 14, 0, Math.PI * 2);
				ctx.fill();
				ctx.font = "bold 28px system-ui";
				ctx.fillText(`${index + 1}일차`, 125, y + 30);
				ctx.font = "24px system-ui";
				const names = day.items
					.filter((i) => i.completed)
					.map((i) => i.title)
					.join(" → ");
				ctx.fillText(
					names.slice(0, 30) || "다음에 이어 걸을 하루",
					125,
					y + 70,
				);
				y += 110;
			}
			const photo =
				trip.filmMoments?.find((m) => m.featured && m.photoDataUrl) ??
				trip.filmMoments?.find((m) => m.photoDataUrl);
			if (photo?.photoDataUrl) {
				const img = new Image();
				await new Promise<void>((resolve, reject) => {
					img.onload = () => resolve();
					img.onerror = () => reject(new Error("PHOTO"));
					img.src = photo.photoDataUrl!;
				});
				const width = 230,
					height = 200;
				ctx.drawImage(img, 800, 30, width, height);
			}
			ctx.fillStyle = "#263d63";
			ctx.font = "26px system-ui";
			ctx.fillText("일본골목 · 여행의 시작부터 돌아온 뒤까지", 64, 1300);
			setUrl(canvas.toDataURL("image/png"));
			setError("");
		} catch {
			setError(
				"이미지를 만들지 못했어요. 사진 없이 다시 시도하거나 여행책을 받아 주세요.",
			);
		}
	}
	return (
		<section>
			<h3>다녀온 여행 요약 카드</h3>
			<p>
				도시·날짜·다녀온 곳과 내 대표 사진만 담아요. 금액·자유메모·숙소
				주소·식사 카드는 담지 않아요.
			</p>
			<button
				type="button"
				className="button secondary"
				onClick={() => void create()}
			>
				요약 카드 만들기
			</button>
			{url && (
				<>
					<img
						src={url}
						width={1080}
						height={1350}
						style={{ maxWidth: "100%", height: "auto" }}
						alt="내 여행 요약 카드"
					/>
					<a
						className="button secondary"
						download="일본골목-요약.png"
						href={url}
					>
						이미지 받기
					</a>
					<button
						type="button"
						className="button primary"
						onClick={async () => {
							try {
								const blob = await (await fetch(url)).blob(),
									file = new File([blob], "일본골목-요약.png", {
										type: "image/png",
									});
								if (!navigator.canShare?.({ files: [file] }))
									throw new Error("NO_FILE_SHARE");
								await navigator.share({ files: [file] });
							} catch {
								setError(
									"파일 공유를 열지 못했어요. 이미지를 받거나 길게 눌러 사진에 저장해 주세요.",
								);
							}
						}}
					>
						이미지 보내기
					</button>
					<p>내려받기가 안 되면 이미지를 길게 눌러 사진에 저장해 주세요.</p>
				</>
			)}
			{error && <p role="alert">{error}</p>}
		</section>
	);
}
